<template>
  <div class="mt-5 div-top">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="title">
            {{ name }}
          </h1>
          <h3 class="description mt-3">
            {{ description }}
          </h3>
        </div>
        <div class="col-lg-12">
          <div class="row align-items-center my-4 cards-wp">
            <div v-for="card in cards" class="col-lg-4 col-6 mt-3" :key="card.id" v-on:click="selectedWallpaper(card)">
              <div class="card-pagination">
                <img class="card-wallpaper-view" :src="card.imgPath" :alt="name" />
                <div class="card-body d-flex flex-column align-items-center">
                  <h5 class="card-title my-3">
                    {{ translate.download }}
                    <font-awesome-icon :icon="['fas', 'download']" style="color: #b20000; margin-left: 5px;font-size: 11px;top:-2px;" />
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Teleport to="body">
    <!-- use the modal component, pass in the prop -->
    <v-modal :show="showModal" @close="openModal">
      <template #header>
        <!--<h3>{{ 'Wallpaper' }}</h3>-->&nbsp;
      </template>
      <template #body>
        <img class="img-selected-modal" :src="imgSelected" :alt="name" />
      </template>
      <template #footer>
        <div class="row w-100 align-items-center justify-content-center">
          <h5 v-if="desktopDownload" class="col-lg-3 cursor-pointer down-option" id="desk" @click="download(true)">
            {{ 'Desktop' }}
            <font-awesome-icon :icon="['fas', 'download']" size="sm" style="color: #b20000; margin-left: 5px;font-size: 11px;top:-2px;" />
          </h5>
          <h5 v-if="mobileDownload" class="col-lg-3 cursor-pointer down-option" @click="download(false)">
            {{ 'Mobile' }}
            <font-awesome-icon :icon="['fas', 'download']" size="sm" style="color: #b20000; margin-left: 5px;font-size: 11px;top:-2px;" />
          </h5>
        </div>
      </template>
    </v-modal>
  </Teleport>
</template>

<script lang="ts">
import VModal from 'components/Modais/Modal.vue'
import { isMobile } from 'views/shared/utils/mobile'

export default {
  name: 'ModelWallpapers',
  props: ['model', 'translate'],
  components: {
    VModal
  },
  created() {
    if (this.model) {
      this.getModel()
    }
  },
  watch: {
    'model': function () {
      this.getModel()
    }
  },
  data() {
    return {
      name: '',
      description: '',
      cards: [],
      showModal: false,
      imgSelected: '',
      desktopDownload: '',
      mobileDownload: '',
      isMobile: isMobile(),
    }
  },
  methods: {
    getModel() {
      this.name = this.model.nameModel
      this.description = this.isMobile ? this.translate.wallpaper : this.model.descriptionModel
      this.cards = this.model.cardsWallPappers
    },
    openModal() {
      this.showModal = !this.showModal
    },
    selectedWallpaper(card) {
      this.imgSelected = card.imgPath
      this.desktopDownload = card.imgDesktop
      this.mobileDownload = card.imgMobile
      this.openModal()
    },
    download(val: boolean) {
      if (val)
        window.open(this.desktopDownload)
      else
        window.open(this.mobileDownload);
    }
  }
}
</script>
<style scoped lang="css">

:deep(.modal-container) {
  width: 500px;
}
.title {
  height: 72px;
  color: #000000;
  font-family: "Bebas-Neue";
  font-size: 72px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 72px;
}

.description {
  color: #B20000;
  font-family: 'Roboto-Medium';
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.card-title {
  cursor: pointer;
  height: 19px;
  color: #666666;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}

.card-wallpaper-view {
  width: 100%;
  height: 300px;
}

.img-selected-modal {
  width: 100%;
}

.down-option {
  height: 19px;
  color: #666666;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}

/* regras mobile 992vp */
@media screen and (max-width: 992px) {
  .card-wallpaper-view {
    width: 100%;
    height: unset;
  }

  .title {
    display: none;
  }

  .description {
    font-weight: 300;
    font-size: 20px;
  }

  .block {
    padding: 10px;
  }

  .cards-wp {
    margin-top: 5px !important;
  }

  .div-top{
    margin-top: 20px !important;
  }

  :deep(.modal-container) {
    width: 95%;
  }  
}
</style>
